import React from 'react'
import PropTypes from 'prop-types'
import ModalCardHead from './ModalCardHead'
import ModalCardTitle from './ModalCardTitle'

/* doc
---
title: ModalCard
name: ModalCard
category: React - Bulma
---

A `ModalCard` component based on Bulma `.modal-card`. A more classic modal,
with a head, a body and a foot

This should be used with `Modal, ModalCardTitle, ModalCardHead, ModalCardBody, ModalCardFoot`

See [Bulma Documentation](http://bulma.io/documentation/components/modal/) for reference and full options.

```html_example
  <Modal>
    <ModalBackground />
    <ModalCard>
      <ModalCardHead>
        <ModalCardTitle>
          ...
        </ModalCardTitle>
      </ModalCardHead>
      <ModalCardBody>
        ...
      </ModalCardBody>
      <ModalCardFoot>
        ...
      </ModalCardFoot>
    </ModalCard>
  </Modal>
```
*/
function ModalCard(props) {
  const {
    className, children, cardTitle, onClose, ...rest
  } = props

  const classes = [
    'bulma-modal-card',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      <ModalCardHead
        onClose={onClose}
      >
        <ModalCardTitle>{props.cardTitle}</ModalCardTitle>
      </ModalCardHead>
      {children}
    </div>
  )
}

ModalCard.defaultProps = {
  cardTitle: {},
  onClose: null,
}

ModalCard.propTypes = {
  // The card title
  cardTitle: PropTypes.node,
  // The function for the close button
  onClose: PropTypes.func,
}

export default ModalCard
